const urls = ['checkoutpage.dev', 'checkoutpage.com', 'checkoutpage.co', 'checkoutpage.vercel.app'];

export default function isCheckoutUrl(origin = '') {
  let isCPUrl = false;

  if (!origin) return false;

  for (let url of urls) {
    if (origin.includes(url)) {
      isCPUrl = true;
    }
  }

  return isCPUrl;
}
